export default "__VITE_ASSET__61ERUI1S__"